// src/components/common/NotificationContainer/NotificationContainer.jsx
import React, { useContext } // useState, useEffect не нужны здесь, если они в NotificationContext
    from 'react';
import Notification from '../Notification/Notification';
import styles from './NotificationContainer.module.css';
import { NotificationContext } from '../../../contexts/NotificationContext'; // Импортируем контекст

const NotificationContainer = () => {
    // Получаем полный доступ к значениям контекста (включая notifications и removeNotification)
    // Для этого нам нужно немного изменить NotificationContext.jsx, чтобы он предоставлял эти значения.

    // Изменим NotificationContext:
    // В NotificationContext.Provider value={{ notifications, addNotification, removeNotification }}>
    // И хук useNotifier будет возвращать то же самое, или создать отдельный хук для контейнера.
    // Пока сделаем проще и модифицируем провайдер.

    // ---- После модификации NotificationContext.jsx ----
    const context = useContext(NotificationContext);
    // Если контекст еще не инициализирован или мы рендеримся вне провайдера (хотя App.jsx должен это предотвратить)
    if (!context) return null;

    const { notifications, removeNotification } = context;


    return (
        <div className={styles.notificationContainer}>
            {notifications.map((notification) => (
                <Notification
                    key={notification.id}
                    id={notification.id}
                    message={notification.message}
                    type={notification.type}
                    onDismiss={removeNotification}
                />
            ))}
        </div>
    );
};

export default NotificationContainer;
